// The outer marketing canvas, including each section's padding.
export const pageFrame = 'mx-auto w-full max-w-[1920px]';
